type FileTypeCategory = 'image' | 'video' | 'audio' | 'code' | 'document' | 'spreadsheet';

const CODE_EXTENSIONS = new Set([
  'js',
  'jsx',
  'ts',
  'tsx',
  'py',
  'java',
  'rb',
  'go',
  'rs',
  'c',
  'cpp',
  'cc',
  'h',
  'hpp',
  'cs',
  'php',
  'html',
  'htm',
  'css',
  'scss',
  'json',
  'xml',
  'sh',
  'sql',
  'yml',
  'yaml',
  'swift',
  'kt',
]);

const SPREADSHEET_EXTENSIONS = new Set([
  'csv',
  'numbers',
  'ods',
  'tsv',
  'xls',
  'xlsm',
  'xlsx',
]);

function getFileExtension(fileName: string): string {
  return fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
}

function getFileTypeCategory(contentType: string, fileName: string): FileTypeCategory {
  if (contentType.startsWith('image/')) {
    return 'image';
  }
  if (contentType.startsWith('video/')) {
    return 'video';
  }
  if (contentType.startsWith('audio/')) {
    return 'audio';
  }

  const extension = getFileExtension(fileName);

  if (CODE_EXTENSIONS.has(extension)) {
    return 'code';
  }
  if (
    contentType.includes('spreadsheetml') ||
    contentType === 'application/vnd.apple.numbers' ||
    contentType === 'application/vnd.ms-excel' ||
    contentType === 'application/vnd.oasis.opendocument.spreadsheet' ||
    SPREADSHEET_EXTENSIONS.has(extension)
  ) {
    return 'spreadsheet';
  }

  return 'document';
}

export type { FileTypeCategory };
export { getFileTypeCategory };
